import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { AlertState } from './types'

export const getters: GetterTree<AlertState, RootState> = {
  alerts (state) {
    return state.alerts
  }
}
